import axiosClient from './axiosClient'

export const authApi = {
  login: (username: string, password: string) =>
    axiosClient.post('/login', { username, password }),

  profile: (token: string) =>
    axiosClient.get('/profile', {
      headers: { Authorization: `Bearer ${token}` },
    }),

  refresh: () =>
    axiosClient.post('/refresh-token', {
      refreshToken: localStorage.getItem('refreshToken'),
    }),

  logout: () =>
    axiosClient.delete('/refresh-token', {
      headers: {
        RefreshToken: `Bearer ${localStorage.getItem('refreshToken')}`,
      },
    }),
}
